const formatPhoneNumber = (phone) => (phone ? phone.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3') : '');

export default formatPhoneNumber;
